const topics = [
  {
    id: 1,
    title: '「硬汉之夜」动作猛片连播',
    desc: '香蕉视频精选动作大片连续放送，从好莱坞到港片经典，全程高能无尿点。本周新增《怒火重案》《杀破狼》系列高清修复版。',
    badge: '本周最热',
    badgeColor: 'bg-red-500',
    icon: 'ri-sword-line',
  },
  {
    id: 2,
    title: '「推理剧场」高能烧脑季',
    desc: '红桃视频独家悬疑推理剧场，汇集国内外高分烧脑剧集。层层反转、悬念迭起，考验你的推理能力，猜到结局算你赢。',
    badge: '口碑推荐',
    badgeColor: 'bg-accent-500',
    icon: 'ri-search-eye-line',
  },
  {
    id: 3,
    title: '「午夜专场」限时特供频道',
    desc: '蜜桃视频每晚 22:00 准时开放午夜专场，精选优质内容限时供应。错过等明天，夜猫子宅男的专属福利，记得定好闹钟。',
    badge: '限时开放',
    badgeColor: 'bg-rose-500',
    icon: 'ri-moon-clear-line',
  },
  {
    id: 4,
    title: '「夏日特供」蜜桃 × 樱花联合企划',
    desc: '两大平台首次联合推出夏日特供专题，覆盖综艺、动漫、午夜三大频道。全量内容免费开放，宅家也能感受夏日激情。',
    badge: '联合企划',
    badgeColor: 'bg-orange-500',
    icon: 'ri-sun-line',
  },
  {
    id: 5,
    title: '「经典重映」港片高清修复全系列',
    desc: '红桃视频经典港片高清修复计划持续进行中，周星驰、成龙、周润发经典作品陆续上线。重温黄金年代的港片辉煌。',
    badge: '经典回顾',
    badgeColor: 'bg-amber-600',
    icon: 'ri-film-line',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">热门专题</h2>
        <p className="section-subtitle">精选五大专题企划，总有一个合你口味</p>
        <div className="mt-10 flex flex-col lg:flex-row gap-4 md:gap-5">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="flex-1 bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden cursor-pointer hover:border-primary-300 transition-colors group"
            >
              <div className="aspect-[16/9] bg-gradient-to-br from-foreground-700 via-foreground-800 to-foreground-900 relative flex items-center justify-center">
                <div className={`w-16 h-16 rounded-full bg-white/10 flex items-center justify-center backdrop-blur-sm group-hover:bg-white/20 transition-colors`}>
                  <i className={`${topic.icon} text-white text-2xl`}></i>
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-0.5 text-white text-[10px] font-medium rounded-full whitespace-nowrap ${topic.badgeColor}`}>
                    {topic.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {topic.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-2">{topic.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}